module.exports = __webpack_public_path__ + "static/img/defaultImage.4eb6eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultImage.png
// module id = REhz
// module chunks = 1